export const UserFields = ['id', 'email', 'fullName', 'role', 'lastSignIn', 'acceptedTermsAndConditions'];
